import { IAddress } from "../address/IAddress";

export enum ApplicantType {
	Institution = 'Institution',
	Fund = 'Fund',
	Person = 'Person',
	All = 'All'
}

export enum InstitutionType {
	None = 'None',
	Exclusive = 'Exclusive',
	Inclusive = 'Inclusive'
}

export interface IApplicant {
    id: number;
    name: string;
    created: number;
    lastUpdated: number;
    type: ApplicantType;
    institutionType: InstitutionType;
    address: IAddress;
    legalEntity?: string;
    hasFiled: boolean;
    hasSigned: boolean;
    hasSignedNDA: boolean;
}